<template>
  <th
    :class="alignCls"
    colspan="1"
    rowspan="1"
  >
    <div :class="cellClasses">
      <template v-if="column.type === 'expand'">
        <span v-if="!column.renderHeader">{{ column.title || '' }}</span>
        <table-render
          v-else
          :render="column.renderHeader"
          :column="column"
          :index="index" />
      </template>
      <template v-else-if="column.type === 'selection'">
        <iCheckbox
          :value="table.isSelectAll"
          :disabled="table.isSelectAllDisabled"
          @on-change="table.onSelectedAllChange" />
      </template>
      <template v-else>
        <span
          v-if="!column.renderHeader"
          :class="{[cssClasses.cellSort]: column.sortable}"
          @click="onToggleSort()"
          @click.shift="onToggleSort({ shift: true })">{{ column.title || '#' }}</span>
        <table-render
          v-else
          :render="column.renderHeader"
          :column="column"
          :index="index"/>

        <span
          v-if="column.sortable"
          :class="[cssClasses.sort]">
          <i
            :class="{on: sortType === 'asc'}"
            class="ivu-icon ivu-icon-arrow-up-b"
            @click="onSort('asc')"
            @click.shift="onSort('asc', { shift: true })" />
          <i
            :class="{on: sortType === 'desc'}"
            class="ivu-icon ivu-icon-arrow-down-b"
            @click="onSort('desc')"
            @click.shift="onSort('desc', { shift: true })" />
        </span>

        <span
          v-if="column.filterable"
          :class="[cssClasses.filter]">
          <i
            :class="{on: table.filters[column.key]}"
            class="ivu-icon ivu-icon-funnel" />
        </span>
      </template>
    </div>
  </th>
</template>
<script>

import tableRender from './table-render';
import Mixin from './mixin';

export default {
  name: 'TableThHeader',
  components: { tableRender },
  mixins: [Mixin],
  inject: ['table', 'cssClasses'],
  props: {
    column: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  computed: {
    alignCls() {
      return this.computeAlignCls(this);
    },
    cellClasses() {
      return [
        this.cssClasses.cell,
      ];
    },
    sortType() {
      const sort = this.table.sort.find(([key]) => key === this.column.key);
      if (!sort) return null;
      const [, order] = sort;
      return order;
    },
  },
  methods: {
    onSort(type, { shift = false } = {}) {
      const order = this.sortType === type ? null : type;
      this.table.onSort({ column: this.column, order, shift });
    },
    onToggleSort({ shift = false } = {}) {
      const { sortable } = this.column;
      if (!sortable) return;

      switch (this.sortType) {
        case 'asc':
          this.onSort('desc', { shift });
          break;
        case 'desc':
          this.onSort(null, { shift });
          break;
        default:
          this.onSort('asc', { shift });
      }
    },
  },
};
</script>
